module.exports = __webpack_public_path__ + "img/Nicole+Jon-22.365e075b.jpg";